async function InfiniteLine(selector, speed) {
  const parentSelector = await Reactor(selector);
  const childSelector = parentSelector.querySelector('h1')
  const clone = parentSelector.innerHTML;
  const firstElement = parentSelector.children[0];
  let i = 0;

  if(childSelector.clientWidth > 1000) {
    maxLoop(parentSelector, 4, clone)
  }
  else if(childSelector.clientWidth < 1000 && childSelector.clientWidth > 600) {
    maxLoop(parentSelector, 7, clone)
  }
  else if(childSelector.clientWidth < 600 && cildSelector.clientWidth > 0) {
    maxLoop(parentSelector, 14, clone)
  }
  

  setInterval(function () {
    firstElement.style.marginLeft = `-${i}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }
    i = i + speed;
  }, 0);
}

function maxLoop(Selector, int, clone) {
  for(let el = 0; el < int; el++) {
    Selector.insertAdjacentHTML('beforeend', clone);
  }
}

async function Reactor(selector) {
  return await htmlChecker(selector)
}

async function htmlChecker(selector, iterate = 0) {
  let check = document.querySelector(selector)
  iterate = iterate + 1
  return new Promise((resolve, reject) => {
    if(check && iterate > 1) {
      resolve(document.querySelector(selector))
    } else {
      setTimeout(() => {
        htmlChecker(selector, iterate).then(resolve)
      }, 300)
    }
  })
}

window.addEventListener('load', InfiniteLine('#iline', 0.4))
